export const TABLE_DATA_TYPES = [
  'sites',
  'routes',
  'contacts',
  'tags',
  'notes',
  'seasons',
  'visits',
  'contact history',
  'site history',
  'users',
  'imports',
  'items_for_distribution',
  'other',
];
